export default "__VITE_ASSET__jqSTqI04__"